import * as React from 'react';

import { cn, FOCUS_RING } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // appearance-none + min-h: iOS Safari ignores `height` on inputs and
        // shrinks them below a 44px touch target. text-base (16px) also stops
        // the focus zoom that makes the field look even shorter.
        'h-11 min-h-11 w-full min-w-0 appearance-none rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,border-color,box-shadow] duration-200 outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30',
        // Same hover as the platform's fields: the border comes up to full ink. border-color has
        // to stay in the transition list above or this snaps.
        'hover:border-foreground disabled:hover:border-input',
        // The platform's field focus: a drop shadow, no ring. Its ui/input.tsx still carries the
        // stock shadcn `ring-[3px] ring-ring/50`, but every field it actually ships — search,
        // editable-field, pagination, textarea — overrides that with shadow-md and ring-0. The
        // border takes --ring here rather than --foreground, which is the only intended change.
        FOCUS_RING,
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
